<template>
  <div class="sm-customers__main">
    <customers-controller
      :list="currentList"
      @update-list="getCustomersList"
      @sort="sortTable"
      @new="$emit('action', 'new')"
      @notif="notif => addNotif = notif"
    />

    <paginate-block
      v-if="currentList.length"
      v-model="pager.onPage"
      :pages="pager.pages" 
      :page="pager.page"
      :onPage="pager.onPage"
      :morePages="morePages"
      :items="pager.items"
      @showMore="getMoreCustomers()"
    />

    <action-notification 
      :add="addNotif"
    />

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import CustomersController from '@/views/admin/pages/customers/components/CustomersController';
import PaginateBlock from '@/components/PaginateBlock';
import Spinner from '@/components/Spinner';

import { mapActions, mapGetters } from 'vuex';
import {CreateQueryString} from '@/utils/url';
import {GetRole, CheckPrivileged} from '@/utils/roles';
import ActionNotification from '@/components/ActionNotification';

export default {
  name: 'customers-main',
  components: {
    'customers-controller': CustomersController,
    'paginate-block': PaginateBlock,
    'sm-spinner': Spinner,
    'action-notification': ActionNotification
  },
  data() {
    return {
      list: [],
      moreList: [],
      currentList: [],
      pager: {
        page: 1,
        pages: 1,
        items: 1,
        onPage: 48
      },
      morePages: 0,
      emptyState: false,
      showSpinner: false,
      defaultSortOrder: {
        attribute_name: 'pmb',
        direction: 'desc'
      },
      defaultSortOrderForInactiveTab: {
        attribute_name: 'registered_on',
        direction: 'desc'
      },
      addNotif: null,
    };
  },
  created() {
    this.showSpinner = true;
    Promise.all([
      this.getPlans(true)
    ])
      .then(([plans]) => {
        this.initQueryParams();
        
        this.getCustomersList();
      });
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      plans: 'plans/plans',
      userAccount: 'account/userAccount',
    })
  },
  methods: {
    ...mapActions({
      getPlans: 'plans/getPlans',
      getCustomers: 'customers/getCustomers',
    }),
    initQueryParams() {
      let query = Object.assign({}, this.$route.query);

      if (query.order) {
        let orderObj = JSON.parse(decodeURIComponent(query.order));

        if (orderObj.attribute_name) 
          this.currentSort = orderObj.attribute_name;

        if (orderObj.direction) 
          this.currentSort = orderObj.direction;
      }

      if (this.isMobile && (query.page || query.limit)) {
        delete query.page;
        delete query.limit;

        this.$router.replace({ query });
      }

      if (query.page)
        this.pager.page = parseInt(query.page);

      if (query.limit)
        this.pager.onPage = parseInt(query.limit);
    },
    getCustomersList(query) {
      this.showSpinner = true;
      this.morePages = 0;

      if (!query)
        query = Object.assign({}, this.$route.query);

      if (!query.limit)
        query.limit = this.pager.onPage;

      query.order = query.order 
                    ? JSON.parse(decodeURIComponent(query.order)) 
                    : (query.tab === 'inactive' ? this.defaultSortOrderForInactiveTab : this.defaultSortOrder);

      if (query.page && parseInt(query.page) > this.list.total_pages)
        query.page = 1;

      if (query.tab != 'all') {
        if (query.tab == 'update')
          return;

        query.is_active = !query.tab || query.tab == 'active';
      }
        
      if (query.tab)
        delete query.tab;

      this.getCustomers({
        isMore: false,
        query: CreateQueryString(query)
      })
        .then(res => {
          this.list = res;
          this.moreList = [];

          this.showSpinner = false;
        });
    },
    getMoreCustomers() {
      this.showSpinner = true;
      this.checkAll = false;
      this.morePages++;
      let query = Object.assign({}, this.$route.query);
      query.page = this.pager.page + this.morePages;

      if (!query.limit)
        query.limit = this.pager.onPage;
      
      query.order = query.order ? JSON.parse(decodeURIComponent(query.order)) : this.defaultSortOrder;

      if (query.tab != 'all') {
        query.is_active = !query.tab || query.tab == 'active';
      }
        
      if (query.tab)
        delete query.tab;

      this.getCustomers({
        isMore: true,
        query: CreateQueryString(query)
      })
        .then(res => {
          this.moreList = [...this.moreList, ...res.customers];

          this.showSpinner = false;
        });
    },
    prepareItems(items) {
      return items.map((item) => {
        const temp = {...item};
// TEMP
temp.has_card = true;
        temp.joint_accounts = null;
        temp.itemOpen = false;
        temp.popupOpen = false;
        temp.is_privileged = CheckPrivileged(item);
        temp.role = GetRole(item);

        return temp;
      }).sort((a, b) => {
        if (a.is_privileged && !b.is_privileged)
          return 1;

        if (!a.is_privileged && b.is_privileged)
          return -1;


        return 0;
      });
    },
    sortTable(params) {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            order: encodeURIComponent(JSON.stringify(params))
          }
        }
      });
    },
  },
  watch: {
    list() {
      this.pager.page = this.list.page;
      this.pager.pages = this.list.total_pages;
      this.pager.items = this.list.total_count;
      this.pager.onPage = parseInt(this.$route.query.limit) || 48;
      this.emptyState = this.list.length == 0;
      this.currentList = this.prepareItems([...this.list.customers, ...this.moreList]);
      this.$emit('action', 'setExportUrl', this.list.csv_urls[this.$route.query.tab || 'active']);
    },
    moreList() {
      this.currentList = this.prepareItems([...this.list.customers, ...this.moreList]);
    },
    '$route.query'(val) {
      this.getCustomersList(Object.assign({}, val));
    },
    userAccount(val) {
      if(val && val.role && val.role === 'mail_admin') {
        this.$router.push('/');
      }
    }
  }
}
</script>
